import { TYPE as PAGE_TYPE } from '@kontentino/kontentino-constants/Pages';
import {
  FB_METRICS_PROPERTIES,
  IG_METRICS_PROPERTIES,
  LI_METRICS_PROPERTIES,
} from 'app/modules/insights/modules/postsPerformance/utils/metricProperty';

export interface MetricConfig {
  key: string;
  title: string;
  description?: string;
}

export const ANALYTICS_LITE_POST_PERFORMANCE: Record<number, MetricConfig[]> = {
  [PAGE_TYPE.INSTAGRAM]: [
    {
      key: IG_METRICS_PROPERTIES.likes.key,
      title: IG_METRICS_PROPERTIES.likes.title,
    },
    {
      key: IG_METRICS_PROPERTIES.engagement.key,
      title: IG_METRICS_PROPERTIES.engagement.title,
    },
    {
      key: IG_METRICS_PROPERTIES.comments.key,
      title: IG_METRICS_PROPERTIES.comments.title,
    },
  ],
  [PAGE_TYPE.FACEBOOK]: [
    {
      key: FB_METRICS_PROPERTIES.totalReachUnique.key,
      title: FB_METRICS_PROPERTIES.totalReachUnique.title,
    },
    {
      key: FB_METRICS_PROPERTIES.postImpressions.key,
      title: FB_METRICS_PROPERTIES.postImpressions.title,
    },
    {
      key: FB_METRICS_PROPERTIES.reactions.key,
      title: FB_METRICS_PROPERTIES.reactions.title,
    },
  ],
  [PAGE_TYPE.LINKEDIN]: [
    {
      key: LI_METRICS_PROPERTIES.postImpressions.key,
      title: LI_METRICS_PROPERTIES.postImpressions.title,
    },
    {
      key: LI_METRICS_PROPERTIES.engagement.key,
      title: LI_METRICS_PROPERTIES.engagement.title,
    },
    {
      key: LI_METRICS_PROPERTIES.reactions.key,
      title: LI_METRICS_PROPERTIES.reactions.title,
    },
  ],
};
